module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top-nav', {
    attrs: {
      "headerColor": "white"
    }
  }), (_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "content programs"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h1', {
    staticClass: "h-l category"
  }, [_vm._v("programs")])]), _c('div', {
    staticClass: "col-12"
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "screen"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'programs-page',
        params: {
          category: _vm.category(_vm.featured.content.category),
          id: _vm.featured.uid
        }
      }
    }
  }, [_c('div', {
    staticClass: "hero"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.featured.main_image.url,
      "alt": "CAAM Programs"
    }
  })]), _c('div', {
    staticClass: "captions gradient"
  }, [_c('h2', {
    staticClass: "h-xl"
  }, [_vm._v(_vm._s(_vm.featured.title))]), _c('h2', {
    staticClass: "h-l"
  }, [_vm._v(_vm._s(_vm.featured.content.date))]), _c('h2', {
    staticClass: "h-l"
  }, [_vm._v(_vm._s(_vm.featured.content.start_time) + " - " + _vm._s(_vm.featured.content.end_time))]), (_vm.featuredVirtual) ? _c('h2', {
    staticClass: "h-l"
  }, [_vm._v(_vm._s(_vm.featuredVirtual))]) : _vm._e()])])], 1) : _vm._e()]), _c('div', {
    staticClass: "col-4_xs-12 titles"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("calendar")])]), _c('div', {
    staticClass: "col-8_xs-12 week",
    attrs: {
      "id": "calendarcontainer"
    }
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v(_vm._s(_vm.day))])]), _vm._l((_vm.week), function(program) {
    return (_vm.week.length > 0) ? _c('div', {
      staticClass: "col-8"
    }, [_c('router-link', {
      staticClass: "dateTime",
      attrs: {
        "to": {
          name: 'programs-page',
          params: {
            category: _vm.category(program.content.category),
            id: program.uid
          }
        }
      }
    }, [_c('h3', {
      staticClass: "h-m"
    }, [_vm._v(_vm._s(program.content.title))]), _c('h4', {
      staticClass: "h-sm"
    }, [_vm._v(_vm._s(program.content.date))]), _c('p', {
      staticClass: "h-sxx"
    }, [_vm._v(_vm._s(program.content.start_time) + " - " + _vm._s(program.content.end_time))])])], 1) : _vm._e()
  }), (_vm.week.length === 0) ? _c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "h-l"
  }, [_vm._v("No events scheduled for this day.")])]) : _vm._e(), _c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "pmargin"
  })]), _vm._l((_vm.children), function(item) {
    return _c('div', {
      staticClass: "col-6_xs-12"
    }, [_c('div', {
      staticClass: "filter"
    }, [_c('div', {
      staticClass: "captions-mobile"
    }, [_c('h2', {
      staticClass: "h-l subpage"
    }, [_vm._v(_vm._s(item.category.toLowerCase()))])]), (!_vm.loading) ? _c('div', {
      staticClass: "screen-smaller"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'programs-overview',
          params: {
            category: _vm.category(item.category)
          }
        }
      }
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": item.main_image.url
      }
    })]), _c('div', {
      staticClass: "captions gradient"
    }, [_c('h2', {
      staticClass: "h-l subpage"
    }, [_vm._v(_vm._s(item.category.toLowerCase()))])])], 1) : _vm._e()])])
  })], 2)])])]) : _vm._e()]), _c('bottom-nav', {
    attrs: {
      "footerColor": "white"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1135b014"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Programs.vue
// module id = 225
// module chunks = 1